import React from "react";
import { CryptoCoin } from "src/components/atoms/CryptoCoin";
import styles from "src/components/molecules/BalanceInfo/styles.module.css";
import { Msg } from "src/i18n/Msg";
import { useRedirect } from "src/navigation/useRedirect";
import { PAGES } from "src/types/navigation";
import { formatNumber } from "src/utils/helpers";

type Props = {
  balance: number;
  total: number;
};

export const BalanceInfo: React.FC<Props> = ({ balance, total }) => {
  const { redirect } = useRedirect();
  const handleClick = () => redirect({ scheme: PAGES.POSITIONS });
  return (
    <div className={styles.balanceWrapper}>
      <div className={styles.balanceItem} onClick={handleClick}>
        <h5>
          {formatNumber(total)} <CryptoCoin fill="#27AE60" />
        </h5>
        <p>
          <Msg id="components.molecules.BalanceInfo.total" />
        </p>
      </div>
      <div className={styles.balanceItem} onClick={handleClick}>
        <h5>
          {formatNumber(balance)} <CryptoCoin fill="#27AE60" />
        </h5>
        <p>
          <Msg id="components.molecules.BalanceInfo.balance" />
        </p>
      </div>
    </div>
  );
};
